import { useEffect } from 'react'
import { useFarmContext } from 'src/Elements/Farm'
import { useDashboardHelpers } from 'src/Hooks'
import { isFlowTheme } from 'src/Libs/utils'

interface Props {
  storageId?: string
  installationId?: string
}

/**
 * Custom hook to load storage, powermeter, location and wallboxes data for the dashboard page
 */
const useLoadDashboardData = ({ installationId, storageId }: Props): void => {
  const { isFarm, isFarmMasterSelected, farmClients, isLoading: isFarmLoading, farmMaster } = useFarmContext()

  const { loadStorageData, loadPowermetersFromClients, loadLocation, isSubDevicesReady } = useDashboardHelpers()
  const storageIdList = isFlowTheme ? [farmMaster?.storageId ?? ''] : farmClients?.map(client => client.storageId) || []

  const storageIds = isFarmMasterSelected ? storageIdList : [storageId || '']

  useEffect(() => {
    if (storageId && !isFarmLoading && isSubDevicesReady) {
      loadStorageData(Number(storageId), Number(installationId)).catch(console.error)
      if (storageIds.length > 0) {
        loadPowermetersFromClients(storageIds).catch(console.error)
      }
      loadLocation(Number(storageId)).catch(console.error)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [installationId, isFarm, isFarmLoading, isSubDevicesReady, storageId, storageIds.join(',')])
}

export default useLoadDashboardData
